




































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import propertyApi from "@/api/propertyApi";
import _ from "lodash";
import QSelect2 from "@/common/qSelect2.vue";

@Component({
  name: "qPropertySelect",
  components: {
    QSelect2,
  },
  directives: {},
})
export default class QPropertySelect extends Vue {
  public propertyList = [];
  public selected = null;
  public mutableLoading = false;
  public propertyName = "";
  public propertySelected = "";

  public search = {
    page: 1,
    name: "",
    notLoading: true,
  };
  @Prop()
  value;
  @Prop({default: false})
  is_contract;
  @Prop({default: null})
  contract_id;
  @Watch("value")
  updateValue(newValue) {
    if (newValue) {
      this.selected = this.value;
      this.updateSelect();
    } else {
      this.selected = null;
      this.propertyName = "";
      this.propertySelected = "";
    }
  }

  updateSelect() {
    const property = this.propertyListGroup.find(
      (item) => item.id === this.selected
    );
    if (property) {
      this.propertySelected = property.id;
      // this.selected = this.propertySelected;
      this.propertyName = property.text;
    }
  }

  async mounted() {
    this.propertyList = [];
    this.selected = this.value;
    // this.propertySelected = "";
    this.getList(this.is_contract, this.contract_id);
  }

  public changed() {
    this.$emit("input", this.selected);
  }

  get propertyListGroup() {
    const propertyList = _.uniqBy(this.propertyList, "text");
    if (this.value) {
      const currentyProperty = this.propertyList.find(
        (item) => item.id == this.value
      );
      if (currentyProperty) {
        for (let index = 0; index < propertyList.length; index++) {
          if (propertyList[index].text === currentyProperty.text) {
            propertyList[index] = currentyProperty;
            break;
          }
        }
      }
    }
    return propertyList;
  }

  get propertyRoom() {
    return this.propertyList.filter((item) => item.text === this.propertyName);
  }

  public async getList(is_contract, contract_id) {
    const result = await propertyApi.getPropertiesForSelectItem({
      per_page: 100000,
      is_contract: is_contract ? 1 : 0,
      contract_id: contract_id,
    });
    if (result) {
      this.propertyList = [
        {
          id: 0,
          text: "",
          rom_number: "",
        },
        ...result.list.map((item) => {
          return {
            id: item.id,
            text: item.name + "/" + item.locationName,
            rom_number: item.room_number,
          };
        }),
      ];
    }
    this.updateSelect();
  }
}
